export default "__VITE_ASSET__DuJcqBgW__"